export const BOOKING_NUMBER_LENGTH = 10

export const VEHICLE_NUMBER_LENGTH = 4
